const firebaseConfig = {
  apiKey: "AIzaSyBWb-DJmasTUsArj7a5WCQvPeHxq1PytV8",
  authDomain: "crypto-tracker-8009b.firebaseapp.com",
  projectId: "crypto-tracker-8009b",
  storageBucket: "crypto-tracker-8009b.appspot.com",
  messagingSenderId: "779635322828",
  appId: "1:779635322828:web:2ed70d3f531b6a4dd0b769"
};

export default firebaseConfig;